import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSettings } from "../../Helpers/SettingsHelper";
import { Paths } from "../../Common/Paths";
import { Button, Card, ProgressSpinner } from "../../Common/Imports";
import FireworksEffect from "../../Components/Particles/Fireworks";
import { useAxios } from "../../Helpers/AxiosHelper";
import { ApiResponse } from "../../Models/Classes";

const Activate: React.FC = () => {
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const config = getSettings();
    const AxiosHelper = useAxios();
    const hasActivated = useRef(false);
    const [showLoader, setShowLoader] = useState<boolean>(true);
    const navigate = useNavigate();
    const [ActivationResult, setActivationResult] = useState<boolean>(false)

    const NavigateToLogin = () => {
        navigate(Paths['Login'].value);
    };

    useEffect(() => {
        if (hasActivated.current) return;
        hasActivated.current = true;

        const UserId = searchParams.get("UserId");
        const token = searchParams.get("Token");

        if (UserId && token) {
            AxiosHelper.post<ApiResponse<boolean>>(`Auth/confirmemail`, { UserId, token })
                .then((response) => {
                    if (response.data.code === 0) {
                        setActivationResult(true);
                    }
                })
                .catch(() => {
                    setActivationResult(false);
                })
                .finally(() => {
                    setShowLoader(false);
                });
        } else {
            setShowLoader(false);
        }
    }, [AxiosHelper, t, searchParams, navigate]);

    function formHeader() {
        return (
            <>
                <img src={`${config.settings.cdnUrl}${Paths.Icon.value}`} alt="logo" className="w-5rem" />
                <h1 className="text-4xl font-light mt-4 text-primary-500">
                    {t("Auth.Login.Header")}
                </h1>
                {
                    showLoader ?
                        <>
                            <p>
                                {t("Auth.ActivateUser.SubHeader")}
                            </p>
                            <ProgressSpinner />
                        </>
                        :
                        <p className="text-error"> {t("Auth.ActivateUser.UserActivationError")} </p>
                }
            </>
        );
    }

    if (ActivationResult)
        return (
            <div
                className="z-5 w-full min-h-screen px-6 text-center flex align-items-center justify-content-center"
                style={{ position: 'relative' }}
            >
                <FireworksEffect />
                <div
                    className="activation-success-card w-full shadow-3"
                    style={{
                        maxWidth: '520px',
                        backgroundColor: '#ffffff',
                        color: '#1f2937',
                        border: '1px solid #dfe7f1',
                        borderRadius: '8px',
                        padding: '2rem',
                        position: 'relative',
                        zIndex: 10
                    }}
                >
                    <div className="flex flex-column align-items-center">
                        <img src={`${config.settings.cdnUrl}${Paths.Icon.value}`} alt="logo" className="w-5rem" />
                        <div
                            className="flex align-items-center justify-content-center mt-4 mb-2 border-circle bg-primary"
                            style={{ width: '3.25rem', height: '3.25rem' }}
                        >
                            <i className="pi pi-check text-white text-2xl" />
                        </div>
                        <h1 className="text-4xl font-light mt-3 mb-2 text-primary-500">
                            {t("Auth.ActivateUser.SuccessTitle")}
                        </h1>
                        <p className="mt-0 mb-4 line-height-3">
                            {t("Auth.ActivateUser.Success")}
                        </p>
                        <Button
                            label={t("Auth.Login.Button")}
                            onClick={NavigateToLogin}
                            className="w-full"
                        />
                    </div>
                </div>
            </div>
        )

    return (
        <div className="z-5 w-full px-6 text-center mt-8" style={{ maxWidth: '500px' }}>
            <Card header={formHeader}>
            </Card>
        </div >
    );
};

export default Activate;
